module.exports = __webpack_public_path__ + "img/avatar4.c85764e6.png";